import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { AddonClient, addonApiRef } from './api/AddonApi';

export const addonPlugin = createPlugin({
  id: 'addon',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: addonApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AddonClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The add-on profiles, mounted at /addons. */
export const AddonPage = addonPlugin.provide(
  createRoutableExtension({
    name: 'AddonPage',
    component: () => import('./components/AddonPage').then(m => m.AddonPage),
    mountPoint: rootRouteRef,
  }),
);
